/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Fulfillment_LabelInputs */

const vi_delivery_fulfillment_label = /** @type {(inputs: Delivery_Fulfillment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình thức giao hàng`)
};

/**

* @param {Delivery_Fulfillment_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const delivery_fulfillment_label = /** @type {((inputs?: Delivery_Fulfillment_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Fulfillment_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_delivery_fulfillment_label(inputs)
});